import Icon from './Icon';

const StarIcon = ({ color, ...props }) => (
  <Icon width="11" height="12" viewBox="0 0 11 12" {...props}>
    <path
      d="M6.44169 0.739983C6.52772 0.494658 6.87466 0.494659 6.9607 0.739984L7.78251 3.08341C7.80995 3.16167 7.87125 3.22336 7.94932 3.25131L10.2769 4.08461C10.5199 4.17163 10.5199 4.5154 10.2769 4.60242L7.94932 5.43572C7.87125 5.46367 7.80995 5.52536 7.78251 5.60362L6.96069 7.94705C6.87466 8.19237 6.52772 8.19237 6.44169 7.94705L5.61987 5.60362C5.59243 5.52536 5.53113 5.46367 5.45306 5.43572L3.12552 4.60242C2.88244 4.5154 2.88244 4.17163 3.12552 4.08461L5.45306 3.25131C5.53113 3.22336 5.59243 3.16167 5.61987 3.08341L6.44169 0.739983Z"
      fill={color}
    />
    <path
      d="M2.58532 6.87194C2.67135 6.62662 3.0183 6.62662 3.10433 6.87194L3.54573 8.13061C3.57317 8.20886 3.63447 8.27056 3.71254 8.29851L4.96648 8.74744C5.20955 8.83446 5.20955 9.17822 4.96648 9.26525L3.71254 9.71418C3.63447 9.74213 3.57317 9.80382 3.54573 9.88208L3.10433 11.1407C3.0183 11.3861 2.67135 11.3861 2.58532 11.1407L2.14392 9.88208C2.11648 9.80382 2.05518 9.74213 1.97711 9.71418L0.723172 9.26525C0.480097 9.17822 0.480097 8.83446 0.723172 8.74744L1.97711 8.29851C2.05518 8.27056 2.11648 8.20886 2.14392 8.13061L2.58532 6.87194Z"
      fill={color}
    />
  </Icon>
);

export default StarIcon;
